import BusinessIcon from "@mui/icons-material/Business";
import CategoryIcon from "@mui/icons-material/Category";
import PublicIcon from "@mui/icons-material/Public";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import StoreIcon from "@mui/icons-material/Store";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import {
  formatNullableBoolean,
  formatNullableNumber,
} from "../../utils/formatters";

export function retailProfileConfig(company = {}) {
  return [
    {
      title: "Retail Concept",
      rows: [
        {
          icon: <BusinessIcon />,
          label: "Company Name",
          value: company.concept,
        },
        {
          icon: <CategoryIcon />,
          label: "Sector",
          value: company.retail_sector,
          showIf: Boolean(company.retail_sector),
        },
        {
          icon: <CategoryIcon />,
          label: "Subsector",
          value: company.retail_subsector,
          showIf: Boolean(company.retail_subsector),
        },
        {
          icon: <PublicIcon />,
          label: "Country",
          value: company.country,
          showIf: Boolean(company.country),
        },
        {
          icon: <StoreIcon />,
          label: "Franchise",
          value: formatNullableBoolean(company.franchise),
          showIf:
            company.franchise !== null && company.franchise !== undefined,
        },
      ],
    },
    {
      title: "Footprint & Growth",
      rows: [
        {
          icon: <TrendingUpIcon />,
          label: "Openings / Closings",
          value: formatNullableNumber(company.openings_closings_next_12_months),
          showIf:
            company.openings_closings_next_12_months !== null &&
            company.openings_closings_next_12_months !== undefined,
        },
        {
          icon: <StoreIcon />,
          label: "Unit Count",
          value: formatNullableNumber(company.unit_count_end_2024),
          showIf:
            company.unit_count_end_2024 !== null &&
            company.unit_count_end_2024 !== undefined,
        },
        {
          icon: <CropSquareIcon />,
          label: "Store Size (Min SF)",
          value: formatNullableNumber(company.typical_store_size_min),
          showIf:
            company.typical_store_size_min !== null &&
            company.typical_store_size_min !== undefined,
        },
        {
          icon: <CropSquareIcon />,
          label: "Store Size (Median SF)",
          value: formatNullableNumber(company.typical_store_size_median),
          showIf:
            company.typical_store_size_median !== null &&
            company.typical_store_size_median !== undefined,
        },
        {
          icon: <CropSquareIcon />,
          label: "Store Size (Max SF)",
          value: formatNullableNumber(company.typical_store_size_max),
          showIf:
            company.typical_store_size_max !== null &&
            company.typical_store_size_max !== undefined,
        },
      ],
    },
  ];
}
